import React from "react";
import DSDModuleSubtopic from "../DSDModuleSubtopic";

const DecoderEncoderModule = () => (
  <DSDModuleSubtopic
    title="Decoder and Encoder"
    videos={[
      "https://www.youtube.com/embed/a3wh7xV5PBU",
      "https://www.youtube.com/embed/NWiPVMDh7GE",
      "https://www.youtube.com/embed/p152s4hR2wo",
      "https://www.youtube.com/embed/vqpGQz5aqBw",
      "https://www.youtube.com/embed/vAUN-jxgUok",
      "https://www.youtube.com/embed/3394TEnBAU0",
      "https://www.youtube.com/embed/H4FkpBAK2Wk",
      "https://www.youtube.com/embed/MJ_zgyaY7Xc"
    ]}
    takeaways={[]}
    questions={[
      { text: `The outputs of a combinational circuit is defined by the following three Boolean functions:
F1(A,B,C) = (1,4,6)
F2(A,B,C) = (3,5)
F3(A,B,C) = (2,4,6,7)
Implement the circuit using 3 x 8 decoder and NAND Gates only.` },
      { text: `Design a combinational circuit with three inputs and output (a) and (b) only using 3: 8 Decoder constructed using 1:2 Decoder implemented using NOR logic in POS form.
(a) The output is 1 when the binary value of the inputs is less than 3. The output is 0 otherwise.
(b) The output is 1 when the binary value of the inputs is an even number.
Write the mixed style Verilog code and test bench with line by line comments of the above design.` },
      { text: `Design a combinational circuit with three inputs x,y,and z and three outputs A,B,C using a Decoder and external gates. 
When the binary input is 0,1,2 or 3, the binary output is two greater than input. 
When the binary input is 4,5,6 or 7, the binary output is two less than the input.` },
      { text: `Design a combinational circuit that has an ability to multiply 2-Bit Unsigned Data. 
The combinational system is expected to implement using only 2:4 Decoders.` },
      { text: `Write a behavioural level Verilog Code for 2:4 Decoder along with Test Bench.` },
      { text: `Identify the logic function implemented using the active low output decoder shown in the figure below. 
Write a code for the identified logic function using Dataflow Verilog HDL with minimal operators.`,
image:"/dsd_14.png" }
    ]}
    exampleVideos={[]}
  />
);

export default DecoderEncoderModule;
